export const resources = {
  services: {
    title: "Services",
    resource: "services",
    columns: [
      { key: "title", label: "Title" },
      { key: "slug", label: "Slug" },
      { key: "sortOrder", label: "Order" },
    ],
    fields: [
      { name: "title", label: "Title", required: true, placeholder: "e.g. Foundation Work" },
      { name: "slug", label: "Slug", required: true, placeholder: "e.g. foundation-work" },
      { name: "summary", label: "Summary", type: "textarea", required: true, placeholder: "Short summary shown on cards" },
      { name: "details", label: "Details", type: "textarea", required: true, placeholder: "Full service description" },
      { name: "sortOrder", label: "Sort order", type: "number", placeholder: "0" },
      { name: "isActive", label: "Active", type: "checkbox" },
    ],
    empty: {
      title: "",
      slug: "",
      summary: "",
      details: "",
      sortOrder: 0,
      isActive: true,
    },
  },
  projects: {
    title: "Projects",
    resource: "projects",
    columns: [
      { key: "title", label: "Title" },
      { key: "category", label: "Category" },
      { key: "status", label: "Status" },
      { key: "year", label: "Year" },
    ],
    fields: [
      { name: "title", label: "Title", required: true, placeholder: "e.g. Verdant Heights Residences" },
      { name: "category", label: "Category", required: true, placeholder: "e.g. Residential" },
      { name: "location", label: "Location", required: true, placeholder: "e.g. Gurugram" },
      { name: "year", label: "Year", required: true, placeholder: "e.g. 2025" },
      { name: "status", label: "Status", required: true, type: "select", options: ["Completed", "Ongoing", "Planned"] },
      { name: "image", label: "Image URL", required: true, placeholder: "https://example.com/project.jpg" },
      { name: "description", label: "Description", type: "textarea", required: true, placeholder: "Brief project description" },
      { name: "sortOrder", label: "Sort order", type: "number", placeholder: "0" },
      { name: "isActive", label: "Active", type: "checkbox" },
    ],
    empty: {
      title: "",
      category: "",
      location: "",
      year: "",
      status: "Completed",
      image: "",
      description: "",
      sortOrder: 0,
      isActive: true,
    },
  },
  gallery: {
    title: "Gallery",
    resource: "gallery",
    columns: [
      { key: "caption", label: "Caption" },
      { key: "altText", label: "Alt text" },
    ],
    fields: [
      { name: "imageUrl", label: "Image URL", required: true, placeholder: "https://example.com/gallery.jpg" },
      { name: "altText", label: "Alt text", required: true, placeholder: "Describe the image" },
      { name: "caption", label: "Caption", required: true, placeholder: "Short caption for the gallery" },
      { name: "sortOrder", label: "Sort order", type: "number", placeholder: "0" },
      { name: "isActive", label: "Active", type: "checkbox" },
    ],
    empty: { imageUrl: "", altText: "", caption: "", sortOrder: 0, isActive: true },
    imageKey: "imageUrl",
  },
  testimonials: {
    title: "Testimonials",
    resource: "testimonials",
    columns: [
      { key: "name", label: "Name" },
      { key: "role", label: "Role" },
    ],
    fields: [
      { name: "quote", label: "Quote", type: "textarea", required: true, placeholder: "Client feedback quote" },
      { name: "name", label: "Name", required: true, placeholder: "e.g. Ananya Mehta" },
      { name: "role", label: "Role", required: true, placeholder: "e.g. Director, Greenleaf Trust" },
      { name: "sortOrder", label: "Sort order", type: "number", placeholder: "0" },
      { name: "isActive", label: "Active", type: "checkbox" },
    ],
    empty: { quote: "", name: "", role: "", sortOrder: 0, isActive: true },
  },
  values: {
    title: "Company Values",
    resource: "values",
    columns: [
      { key: "title", label: "Title" },
      { key: "text", label: "Text" },
    ],
    fields: [
      { name: "title", label: "Title", required: true, placeholder: "e.g. Safety First" },
      { name: "text", label: "Text", type: "textarea", required: true, placeholder: "Describe this company value" },
      { name: "sortOrder", label: "Sort order", type: "number", placeholder: "0" },
      { name: "isActive", label: "Active", type: "checkbox" },
    ],
    empty: { title: "", text: "", sortOrder: 0, isActive: true },
  },
  milestones: {
    title: "Milestones / Stats",
    resource: "milestones",
    columns: [
      { key: "value", label: "Value" },
      { key: "label", label: "Label" },
    ],
    fields: [
      { name: "value", label: "Value", required: true, placeholder: "e.g. 15+" },
      { name: "label", label: "Label", required: true, placeholder: "e.g. Years of experience" },
      { name: "sortOrder", label: "Sort order", type: "number", placeholder: "0" },
      { name: "isActive", label: "Active", type: "checkbox" },
    ],
    empty: { value: "", label: "", sortOrder: 0, isActive: true },
  },
  timeline: {
    title: "Timeline",
    resource: "timeline",
    columns: [
      { key: "year", label: "Year" },
      { key: "title", label: "Title" },
    ],
    fields: [
      { name: "year", label: "Year", required: true, placeholder: "e.g. 2010" },
      { name: "title", label: "Title", required: true, placeholder: "e.g. Founded with purpose" },
      { name: "text", label: "Text", type: "textarea", required: true, placeholder: "Describe this milestone" },
      { name: "sortOrder", label: "Sort order", type: "number", placeholder: "0" },
      { name: "isActive", label: "Active", type: "checkbox" },
    ],
    empty: { year: "", title: "", text: "", sortOrder: 0, isActive: true },
  },
  "process-steps": {
    title: "Process Steps",
    resource: "process-steps",
    columns: [
      { key: "step", label: "Step" },
      { key: "title", label: "Title" },
    ],
    fields: [
      { name: "step", label: "Step code", required: true, placeholder: "e.g. 01" },
      { name: "title", label: "Title", required: true, placeholder: "e.g. Consult" },
      { name: "text", label: "Text", type: "textarea", required: true, placeholder: "Describe this process step" },
      { name: "sortOrder", label: "Sort order", type: "number", placeholder: "0" },
      { name: "isActive", label: "Active", type: "checkbox" },
    ],
    empty: { step: "", title: "", text: "", sortOrder: 0, isActive: true },
  },
  careers: {
    title: "Careers",
    resource: "careers",
    columns: [
      { key: "title", label: "Title" },
      { key: "type", label: "Type" },
      { key: "location", label: "Location" },
    ],
    fields: [
      { name: "title", label: "Title", required: true, placeholder: "e.g. Project Engineer" },
      { name: "type", label: "Job type", required: true, placeholder: "e.g. Full-time" },
      { name: "location", label: "Location", required: true, placeholder: "e.g. Gurugram" },
      { name: "summary", label: "Summary", type: "textarea", required: true, placeholder: "Role summary and responsibilities" },
      { name: "sortOrder", label: "Sort order", type: "number", placeholder: "0" },
      { name: "isActive", label: "Active", type: "checkbox" },
    ],
    empty: { title: "", type: "Full-time", location: "", summary: "", sortOrder: 0, isActive: true },
  },
  founders: {
    title: "Founders",
    resource: "founders",
    columns: [
      { key: "name", label: "Name" },
      { key: "designation", label: "Designation" },
    ],
    fields: [
      { name: "name", label: "Name", required: true, placeholder: "e.g. Rajesh Kumar Sharma" },
      { name: "designation", label: "Designation", required: true, placeholder: "e.g. Founder & Managing Director" },
      { name: "image", label: "Image URL", required: true, placeholder: "https://example.com/founder.jpg" },
      { name: "bio", label: "Bio", type: "textarea", required: true, placeholder: "Short biography of the founder" },
      { name: "quote", label: "Quote", type: "textarea", placeholder: "Optional inspiring quote" },
      { name: "sortOrder", label: "Sort order", type: "number", placeholder: "0" },
      { name: "isActive", label: "Active", type: "checkbox" },
    ],
    empty: {
      name: "",
      designation: "",
      image: "",
      bio: "",
      quote: "",
      sortOrder: 0,
      isActive: true,
    },
    imageKey: "image",
  },
};
